<div class="signin-container">
    <!-- Loading Overlay saat cek autentikasi -->
    <div *ngIf="isCheckingAuth" class="signin-loading">
        <div class="signin-loading-card">
            <div class="signin-loading-spinner"></div>
            <p class="signin-loading-text">Memeriksa autentikasi...</p>
        </div>
    </div>

    <!-- 2-Column Split Layout -->
    <div class="signin-layout" *ngIf="!isCheckingAuth">

        <!-- Left Side — Internal Corporate Branding -->
        <div class="signin-brand-panel">
            <div class="brand-panel-content">
                <div class="brand-tagline">
                    <span class="tagline-bar"></span>
                    <span class="tagline-text">PORTAL INTERNAL</span>
                </div>
                <h1 class="brand-title">
                    <span class="title-white">Av1a</span>
                    <span class="title-accent">Super Apps</span>
                </h1>
                <p class="brand-desc">
                    Sistem manajemen operasional dan administrasi internal Adhivasindo Group.
                </p>
            </div>
        </div>

        <!-- Right Side — Login Form Panel -->
        <div class="signin-form-panel">
            <div class="signin-card">
                <!-- Company Logo (Direct on white card) -->
                <div class="signin-card-logo">
                    <img src="assets/images/logo/adhivasindo-logo.webp" alt="PT Adhivasindo" class="brand-logo-img" />
                </div>

                <div class="signin-header">
                    <h2 class="signin-title">Masuk ke Akun</h2>
                    <p class="signin-subtitle"></p>
                </div>

                <!-- Error Alert Message -->
                <div *ngIf="errorMessage" class="signin-error">
                    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                    </svg>
                    <span>{{ errorMessage }}</span>
                </div>

                <!-- Form -->
                <form (ngSubmit)="onSignIn()" class="signin-form">
                    <!-- Username -->
                    <div class="form-group">
                        <label for="username" class="form-label">Username</label>
                        <div class="form-input-wrapper">
                            <svg class="form-input-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                            </svg>
                            <input id="username" type="text" [(ngModel)]="credentials.username" name="username"
                                class="form-input" placeholder="Masukkan username" [disabled]="isLoading" required
                                autocomplete="username" autofocus />
                        </div>
                    </div>

                    <!-- Password -->
                    <div class="form-group">
                        <div class="form-label-row">
                            <label for="password" class="form-label">Kata Sandi</label>
                            <button type="button" class="forgot-password-link" (click)="onForgotPassword()">
                                Lupa Kata Sandi?
                            </button>
                        </div>
                        <div class="form-input-wrapper">
                            <svg class="form-input-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                            </svg>
                            <input id="password" [type]="showPassword ? 'text' : 'password'"
                                [(ngModel)]="credentials.password" name="password" class="form-input"
                                placeholder="Masukkan kata sandi" [disabled]="isLoading" required />
                            <button type="button" class="form-toggle-password" (click)="showPassword = !showPassword"
                                tabindex="-1" aria-label="Toggle Password Visibility">
                                <!-- Eye Open -->
                                <svg *ngIf="!showPassword" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                    stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                </svg>
                                <!-- Eye Closed -->
                                <svg *ngIf="showPassword" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                                    stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                        d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                                </svg>
                            </button>
                        </div>
                    </div>

                    <!-- Submit Button -->
                    <button type="submit" [disabled]="isLoading || isSsoLoading" class="signin-submit">
                        <span *ngIf="!isLoading">Masuk ke Sistem</span>
                        <ng-container *ngIf="isLoading">
                            <div class="spinner"></div>
                            <span>Memproses...</span>
                        </ng-container>
                    </button>
                </form>

                <!-- SSO Section -->
                <div class="signin-sso-section">
                    <div class="signin-sso-divider">
                        <span class="divider-line"></span>
                        <span class="divider-text">atau masuk dengan</span>
                        <span class="divider-line"></span>
                    </div>

                    <button type="button" (click)="onSsoLogin()" [disabled]="isLoading || isSsoLoading" class="signin-sso-btn">
                        <svg class="sso-btn-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM12 19.2C9.5 19.2 7.29 17.92 6 15.98C6.03 13.99 10 12.9 12 12.9C13.99 12.9 17.97 13.99 18 15.98C16.71 17.92 14.5 19.2 12 19.2Z" fill="#1B5091"/>
                        </svg>
                        <span *ngIf="!isSsoLoading">Akun SSO Adhivasindo Labs</span>
                        <ng-container *ngIf="isSsoLoading">
                            <div class="sso-spinner"></div>
                            <span>Menghubungkan ke SSO...</span>
                        </ng-container>
                    </button>
                </div>

                <!-- Footer -->
                <div class="signin-footer">
                    <p>&copy; {{ currentYear }} <strong>Adhivasindo Group</strong>. All rights reserved.</p>
                </div>
            </div>
        </div>

    </div>
</div>